// extracted by mini-css-extract-plugin
export default {"recommendation-footer":"RecommendationFooter_recommendation-footer__RjVoW"};